$(document).ready(function() {


	$("span.fechar").click(function () {
		$("section.popup").fadeOut();
	});

	$("a.whats").click(function () {
		$("section.popup").hide();
		$(this).closest(".whats-content").find("section.popup").fadeIn();

	});


	$(".fancy").fancybox({
		helpers: {
			title: {
				type: "inside"
			},
			overlay: {
				locked: false
			}
		},
		afterShow: function() {
			$(":text").setMask();
		}
	});
	
	if ($(".popup").length) {
		$(".popup a:first").trigger("click");
	}
	
	/*$('[data-menu]').each(function(){
		var menu = $(this).data('menu');
		if ($('body').is('.'+menu)) {
			$(this).find('a:eq(0)').addClass('actv');
		}
	});*/
	
	//owl carousel
	
	var props = {
		autoplay: true,
		autoplayTimeout: 7000,
		dots: true,
		merge:false,
		loop:true,
		items:1
	};
	
	props['animateOut'] = 'flipOutY';
	props['animateIn'] = 'flipinX';
	
	$(".card-banner").owlCarousel(props);
	
	//Retorna top
	function axysY() {
		return $(window).scrollTop();
	}
	
	$(window).on('scroll load', function() {
		var scrollTop = axysY();
		if(scrollTop > 0) {
			$('.site-header .navigation .logo-menu').addClass('menu-scroled');
		} else {
			$('.site-header .navigation .logo-menu').removeClass('menu-scroled');
		}
	});
	
	var carouselSettings = {
		arrows: true
	};
	
	$(".carousel").slick(carouselSettings);
	
	var carouselKitsSettings = {
		appendArrows: ".carousel-arrows",
		arrows: true,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};
	
	$(".carousel-kits").slick(carouselKitsSettings);
	
	/*
	$("body").on("click", ".btn-buy", function(e) {
		e.preventDefault();
		$(this)
		.addClass("active")
		.find(".icon-target")
		.html('<i class="fa fa-check" aria-hidden="true"></i>');
	});
	*/
	
	var carouselTestimonialSettings = {
		arrows: false,
		dots: true
	};
	
	$(".testimonial-carousel").slick(carouselTestimonialSettings);
	
	$(".accordeon > .open-div").on("click", function() {
		var target = $(this).next(".opened-div");
		
		if (target.is(":hidden")) {
			$(".open-div").removeClass("opened");
			$(this).addClass("opened");
			$(".opened-div").slideUp(200);
			target.slideDown(200).addClass("opened");
		} else {
			$(this).removeClass("opened");
			target.slideUp(200).removeClass("opened");
		}
	});
	
	var aboutUsSettings = {
		arrows: true,
		dots: true
	};
	
	$(".carousel-about-us").slick(aboutUsSettings);
	
	var settingsRelated = {
		slidesToShow: 5,
		appendArrows: ".carousel-arrows",
		arrows: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};
	
	$(".more-items").slick(settingsRelated);
	
	var range = document.getElementById("range");
	if (range) {
		var $valor_de = $("[name=valor_de]");
		var $valor_ate = $("[name=valor_ate]");
		var $inputs = [$valor_de, $valor_ate];
		
		var valor_de = $valor_de.val() | 0;
		var valor_ate = $valor_ate.val() | 0;
		
		var min = $(range).data("min") | 0;
		var max = $(range).data("max") | 0;
		
		if (valor_ate == 0) {
			valor_ate = max;
		}
		
		noUiSlider.create(range, {
			start: [valor_de, valor_ate],
			connect: true,
			step: 1,
			range: {
				min: min,
				max: max
			}
		});
		
		range.noUiSlider.on("update", function(values, handle) {
			$inputs[handle]
			.val(values[handle].number_format(0, ",", ""))
			.trigger("change");
		});
		
		$("body").on("change", "[name=valor_de],[name=valor_ate]", function() {
			var $form = $(this).closest("form");
			var $value = $form.find(".range-value");
			
			var de, ate;
			if ($valor_de.val() == "") {
				de = min;
			} else {
				de = $valor_de.val() | 0;
			}
			
			if ($valor_ate.val() == "") {
				ate = max;
			} else {
				ate = $valor_ate.val() | 0;
			}
			
			de = "R$" + de.number_format(0, ",", ".");
			ate = "R$" + ate.number_format(0, ",", ".");
			
			$value.html("Preço: " + de + " - " + ate);
		});
		
		$("[name=valor_de],[name=valor_ate]").trigger("change");
	}
	
	$(".open-sub").on("click", function() {
		var submenu = $(this).next("ul");
		if (submenu.is(":hidden")) {
			$(".open-sub")
			.next("ul")
			.slideUp();
			submenu.slideDown();
		} else {
			submenu.slideUp();
		}
	});
	
	$(".btn-menu-offset").on("click", function() {
		$("body").toggleClass("menu-opened");
	});
});

var language = "br";
var Modelo = {
	init: function() {
		language = $("meta[name=language]").attr("content");
		
		Modelo.ajaxForm(
			"[name=formNewsletter],[name=formContato],[name=formOrcamento]"
			);
			
			$("input[alt=phone]").each(function() {
				$(this).click(function() {
					$.mask.masks.phone.mask = "(99) 9999-99999";
					$(":text").setMask();
				});
				$(this).blur(function() {
					var phone, element;
					element = $(this);
					phone = element.val().replace(/\D/g, "");
					if (phone.length > 10) {
						element.setMask("(99) 99999-9999?9");
					} else {
						element.setMask("(99) 9999-9999?9");
					}
				});
			});
			
			$("body").on("change", "[name=formOrdenamento] select", function() {
				//console.log('foi');
				$(this)
				.closest("form")
				.submit();
			});
			
			$("body").on("submit", "[name=formTrabalheConosco]", function() {
				var $self = $(this);
				
				if ($self.data("enviando")) return false;
				if (!$self.find(".required").validate()) return false;
				
				$self.data("enviando", true);
				$.fancybox.showLoading();
				
				var callback = function(resp) {
					if (resp.redirect_url != undefined) {
						location.href = resp.redirect_url;
						return;
					}
					
					$.fancybox.hideLoading();
					$self.data("enviando", false);
					if (resp.popup_url != undefined) {
						$.fancybox.open([
							{
								href: resp.popup_url,
								type: ajax
							}
						]);
					}
					alert(resp.msg);
					if (resp.success) {
						$self[0].reset();
						$self.find(".btn-upload").val("Selecionar");
						$self.find("[name*=curriculo]").remove();
					}
				};
				
				$.ajax({
					url: $self.attr("action") + "?t=" + Date.now(),
					method: "post",
					dataType: "json",
					data: $self.serializeArray(),
					success: callback,
					error: function() {
						callback({
							success: false,
							msg: "Não foi possível enviar o formulário."
						});
					}
				});
				
				return false;
			});

			$("body").on("submit", "[name=formSearch]", function() {
				var busca = $('[name=formSearch] [name="buscar"]').val();
				dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
				dataLayer.push({
					event: "search",
					ecommerce: {
						search_term: busca
					}
				});
			});
		},
		
		ajaxForm: function(selector, cb) {
			$("body").on("submit", selector, function() {
				var $self = $(this);
				if ($self.data("enviando")) return false;
				if (!$self.find(".required").validate()) return false;
				
				$self.data("enviando", true);
				$.fancybox.showLoading();
				
				grecaptcha.ready(function () {
					grecaptcha.execute(window.recaptcha_site_key, { action: 'submit' }).then(function (token) {
						$self.find('[name=recaptcha_token]').remove();
						$self.append('<input type="hidden" name="recaptcha_token" value="' + token + '">');
						
						var callback = function(resp) {
							if (resp.redirect_url != undefined) {
								location.href = resp.redirect_url;
								return;
							}
							$self.data("enviando", false);
							$.fancybox.hideLoading();
							
							if (cb) return cb(resp, $self);
							alert(resp.msg);
							if (resp.success) {
								$self[0].reset();
								$self.find("[alt=phone]").val("");
								if (resp.redirect_url != undefined) {
									location.href = resp.redirect_url;
								} else {
									console.log("reload");
									location.reload();
								}
							}
						};
						
						$.ajax({
							url: $self.attr("action") + "?t=" + Date.now(),
							type: "post",
							dataType: "json",
							data: $self.serializeArray(),
							success: callback,
							error: function() {
								callback({
									success: false,
									msg: "Não foi possível enviar o formulário."
								});
							}
						});
					});
				}); 
				return false;
			});
		}
	};
	$(document).ready(function() {
		$(Modelo.init);
	});
	
	/**
	* MEDIAS
	*/
	// > 1024 pixels
	//if($(window).width() > 1024) {
	
	//Habilita Máscara apenas para desktops
	$(function() {
		$.mask.masks.phone.mask = "(99) 9999-99999";
		$(":text").setMask();
	});
	//}
	
	function openFase(evt, fase) {
		// Declare all variables
		var i, tabcontent, tablinks;
		
		// Get all elements with class="tabcontent" and hide them
		tabcontent = document.getElementsByClassName("tabcontent");
		for (i = 0; i < tabcontent.length; i++) {
			tabcontent[i].style.display = "none";
		}
		
		// Get all elements with class="tablinks" and remove the class "active"
		tablinks = document.getElementsByClassName("tablinks");
		for (i = 0; i < tablinks.length; i++) {
			tablinks[i].className = tablinks[i].className.replace(" active", "");
		}
		
		// Show the current tab, and add an "active" class to the button that opened the tab
		document.getElementById(fase).style.display = "block";
		evt.currentTarget.className += " active";
	}
	
	
	(function(){
		var timer;
		$('body').on('change', '[name=formFiltros] [name^=filtros]', function() {
			var $form = $(this).closest('form');
			if (timer) {
				window.clearTimeout(timer);
			}
			timer = window.setTimeout(function() {
				$.fancybox.showLoading();
				$form.trigger('submit');
			}, 1000);
		});
	}());